import PressLogos from "./PressLogos";

export default PressLogos;
